import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

const EnumerationsRouter = {
  path: '/enumerations',
  component: Management,
  redirect: '/enumerations/list',
  meta: {
    auth: Auth.listEnumerations
  },
  children: [
    // 汽车品牌的型号
    {
      path: 'car_brands/:id/car_types',
      component: () => import('@/views/enumerations/details/CarTypes'),
      meta: {
        auth: Auth.listEnumerations
      }
    },
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/enumerations/List'),
      redirect: '/enumerations/list/ChargerBrand',
      meta: {
        auth: Auth.listEnumerations
      },
      children: [
        {
          path: 'ChargerBrand',
          component: () => import('@/views/enumerations/ListTable'),
          meta: {
            auth: Auth.listEnumerations,
            tabName: 'ChargerBrand'
          }
        },
        {
          path: 'CarBrand',
          component: () => import('@/views/enumerations/ListTable'),
          meta: {
            auth: Auth.listEnumerations,
            tabName: 'CarBrand'
          }
        },
        {
          path: 'ChargerType',
          component: () => import('@/views/enumerations/ListTable'),
          meta: {
            auth: Auth.listEnumerations,
            tabName: 'ChargerType'
          }
        },
        {
          path: 'PlugType',
          component: () => import('@/views/enumerations/ListTable'),
          meta: {
            auth: Auth.listEnumerations,
            tabName: 'PlugType'
          }
        },
        {
          path: 'ChargeRate',
          component: () => import('@/views/enumerations/ListTable'),
          meta: {
            auth: Auth.listEnumerations,
            tabName: 'ChargeRate'
          }
        }
      ]
    }
  ]
}

export default EnumerationsRouter
